/* eslint-disable no-extend-native */
Array.prototype.getClosestDown = function (find) {
  function getMedian(low, high) {
    return low + ((high - low) >> 1);
  }

  let low = 0;
  let high = this.length - 1;
  let i;

  while (low <= high) {
    i = getMedian(low, high);
    if (this[i] === find) {
      return this[i];
    }
    if (this[i] > find) {
      high = i - 1;
    } else {
      low = i + 1;
    }
  }

  return this[Math.max(0, low - 1)];
};

const initMultiPackEvents = function () {
  if ($('#subscriptionview').find('.multi-pack-list').length > 0 || $('#orderview').find('.multi-pack-list').length > 0) {
    $(document)
      .off('change.sorMultiPack', '.input-quantity')
      .on('change.sorMultiPack', '.input-quantity', function () {
        const $card = $(this).closest('.card');
        const $multiPackList = $card.find('.multi-pack-list');
        if (!$multiPackList.length) return;

        const arrValues = [];
        $multiPackList.find('.multi-pack-items').each(function (index, elem) {
          arrValues.push(parseInt($(elem).attr('data-quantity')));
        });

        const value = parseInt($(this).val());
        const $priceValue = $card.find('.price').find('.value');
        arrValues.forEach(function (item) {
          if (value === item) {
            const updatedPriceWithMultiPack = $multiPackList
              .find(`.multi-pack-items[data-quantity="${value}"]`)
              .attr('data-unitprice-subscription');
            if (updatedPriceWithMultiPack) $priceValue.text(updatedPriceWithMultiPack);
          } else {
            const intervalLowest = $multiPackList
              .find(`.multi-pack-items[data-quantity="${arrValues.getClosestDown(value)}"]`)
              .attr('data-unitprice-subscription');
            if (intervalLowest) $priceValue.text(intervalLowest);
          }
        });
      });
  }
};

module.exports = {
  initMultiPackEvents: initMultiPackEvents
};
